import ApiBotMaker from './ApiBotMaker';

class BotsAPI extends ApiBotMaker {
  constructor() {
    super('bots', { accountScoped: true });
  }
}

export default new BotsAPI();
